// native
import { Injectable } from '@angular/core';

import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

// service
import { PreferencesService } from '../services/preferences.service';

@Injectable({
  providedIn: 'root'
})
export class DemoGuard  {

  constructor(
    private router: Router,
    private preferencesService: PreferencesService) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (this.preferencesService.isDemoModeEnabled) {
      this.router.navigate(['/demo-mode']);
      return false;
    }
    return true;
  }
}
